import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { AGENT_TABS } from '@/lib/constants';

/** Navigation only: the existing detail sections remain responsible for authorization. */
export function AgentSectionLinks({ agentId }: { agentId: string }) {
  const { t } = useTranslation();
  return (
    <nav aria-label={t('inspector.agentSections')} className="flex flex-col gap-2">
      <div className="grid grid-cols-2 gap-1.5">
        {AGENT_TABS.filter((tab) => tab !== 'overview').map((tab) => (
          <Link
            key={tab}
            to="/agents/$id"
            params={{ id: agentId }}
            search={{ tab }}
            className="rounded-md border border-border px-2.5 py-2 text-sm text-fg-2 hover:bg-hover focus-visible:outline-2 focus-visible:outline-accent"
          >
            {t(`inspector.sections.${tab}`)}
          </Link>
        ))}
      </div>
    </nav>
  );
}
